export const getEndDate = (beginDate: Date): Date => {
	const today = new Date();
	const begin = new Date(beginDate);
	const end = new Date(begin);
	end.setMonth(end.getMonth() + 1);
	return end > today ? today : end;
};